class EasingFormulas {
  LINEAR(k) {
    return k;
  }
  // this ease function replaces QUADRATIC, QUNTIC, and everything in between and beyond
  // a curve of 30 corresponds to QUADRATIC
  EASE_IN(k, curve) {
    const exp = Math.pow(10, curve / 100);
    return Math.pow(k, exp);
  }
  EASE_OUT(k, curve) {
    // is this the same as EASE_IN with a negative curve?
    const exp = Math.pow(10, curve / 100);
    return 1 - Math.pow(1 - k, exp);
  }
  EASE_IN_OUT(k, curve) {
    if (k < 0.5) {
      return this.EASE_IN(2 * k, curve) / 2;
    }
    return this.EASE_OUT(2 * (k - 0.5), curve) / 2 + 0.5;
  }

  SINUSOIDAL_IN(k) {
    return 1 - Math.cos((k * Math.PI) / 2);
  }
  SINUSOIDAL_OUT(k) {
    return Math.sin((k * Math.PI) / 2);
  }
  SINUSOIDAL_IN_OUT(k) {
    return 0.5 * (1 - Math.cos(Math.PI * k));
  }

  // IN_OUT version should use the IN and OUT functions
  EXPONENTIAL_IN(k) {
    return k === 0 ? 0 : Math.pow(1_024_000, k - 1);
  }
  EXPONENTIAL_OUT(k) {
    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
  }
  EXPONENTIAL_IN_OUT(k) {
    if (k === 0) {
      return 0;
    }
    if (k === 1) {
      return 1;
    }
    if ((k *= 2) < 1) {
      return 0.5 * Math.pow(1024, k - 1);
    }
    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
  }
  CIRCULAR_IN(k) {
    return 1 - Math.sqrt(1 - k * k);
  }
  CIRCULAR_OUT(k) {
    return Math.sqrt(1 - --k * k);
  }
  CIRCULAR_IN_OUT(k) {
    if ((k *= 2) < 1) {
      return -0.5 * (Math.sqrt(1 - k * k) - 1);
    }
    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
  }
  ELASTIC_IN(k) {
    let s;
    let a = 0.1;
    const p = 0.4;

    if (k === 0) {
      return 0;
    }
    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = (p * Math.asin(1 / a)) / (2 * Math.PI);
    }

    return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin(((k - s) * (2 * Math.PI)) / p));
  }
  ELASTIC_OUT(k) {
    let s;
    let a = 0.1;
    const p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = (p * Math.asin(1 / a)) / (2 * Math.PI);
    }

    return a * Math.pow(2, -10 * k) * Math.sin(((k - s) * (2 * Math.PI)) / p) + 1;
  }
  ELASTIC_IN_OUT(k) {
    let s;
    let a = 0.1;
    const p = 0.4;

    if (k === 0) {
      return 0;
    }

    if (k === 1) {
      return 1;
    }

    if (!a || a < 1) {
      a = 1;
      s = p / 4;
    } else {
      s = (p * Math.asin(1 / a)) / (2 * Math.PI);
    }

    if ((k *= 2) < 1) {
      return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin(((k - s) * (2 * Math.PI)) / p));
    }

    return a * Math.pow(2, -10 * (k -= 1)) * Math.sin(((k - s) * (2 * Math.PI)) / p) * 0.5 + 1;
  }
  BACK_IN(k) {
    if (k === 0) return 0;
    const s = 1.701_58;

    return k * k * ((s + 1) * k - s);
  }
  BACK_OUT(k) {
    const s = 1.701_58;

    return --k * k * ((s + 1) * k + s) + 1;
  }
  BACK_IN_OUT(k) {
    const s = 1.701_58 * 1.525;

    if ((k *= 2) < 1) {
      return 0.5 * (k * k * ((s + 1) * k - s));
    }

    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
  }
  BOUNCE_IN(k) {
    return 1 - this.BOUNCE_OUT(1 - k);
  }
  BOUNCE_OUT(k) {
    if (k < 1 / 2.75) {
      return 7.5625 * k * k;
    } else if (k < 2 / 2.75) {
      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
    } else if (k < 2.5 / 2.75) {
      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
    } else {
      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984_375;
    }
  }
  BOUNCE_IN_OUT(k) {
    return k < 0.5 ? this.BOUNCE_IN(k * 2) * 0.5 : this.BOUNCE_OUT(k * 2 - 1) * 0.5 + 0.5;
  }
}

const easingFormulas = new EasingFormulas();
export { EasingFormulas, easingFormulas };